module.exports = __webpack_public_path__ + "static/stiefel-name-f85ec0580d3a071136b9d3e4913c0cc2.jpeg";